export const MONTHLY_CLAIM_FORM_LOADING = 'MONTHLY_CLAIM_FORM_LOADING';
export const MONTHLY_CLAIM_FORM_LOAD_ERROR = 'MONTHLY_CLAIM_FORM_LOAD_ERROR';
export const MONTHLY_CLAIM_FORM_GET_REPORT = 'MONTHLY_CLAIM_FORM_GET_REPORT';
export const MONTHLY_CLAIM_FORM_CLEAR_ERRORS =
  'MONTHLY_CLAIM_FORM_CLEAR_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/monthlyclaimform/state/report/types.js